import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-gradient-to-br from-blue-50 to-gray-100 overflow-hidden" data-id="element-160">
      <div className="absolute inset-0 opacity-10" data-id="element-161">
        <div className="absolute top-20 left-10 w-40 h-40 rounded-full bg-yellow-400" data-id="element-162"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full bg-blue-500" data-id="element-163"></div>
        <div className="absolute top-40 right-20 w-20 h-20 rounded-full bg-red-500" data-id="element-164"></div>
      </div>
      <div className="container mx-auto px-4 py-20 md:py-32 relative" data-id="element-165">
        <div className="max-w-3xl" data-id="element-166">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6" data-id="element-167">
            Human-centered design meets innovative technology
          </h1>
          <p className="text-xl text-gray-600 mb-8" data-id="element-168">
            We craft beautiful, functional applications with clean design
            principles and cutting-edge AI capabilities.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-169">
            <a href="#contact" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2" data-id="element-170">
              Get in touch <ArrowRightIcon size={18} data-id="element-171" />
            </a>
            <a href="#services" className="px-6 py-3 bg-white text-gray-800 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-172">
              Explore our services
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" data-id="element-173"></div>
    </section>;
}